export const GUEST_ID_STORAGE_KEY = "ncludeGuestId";
export const GUEST_RESUME_EXPIRY_STORAGE_KEY = "ncludeGuestResumeExpiresAt";

export type GuestResumeStatus = "valid" | "expired" | "missing";

export const getGuestId = () => localStorage.getItem(GUEST_ID_STORAGE_KEY);

export const storeGuestId = (guestId?: string | null) => {
  if (guestId) localStorage.setItem(GUEST_ID_STORAGE_KEY, guestId);
};

type ResponseHeaders = Headers | {
  get?: (name: string) => unknown;
  [name: string]: unknown;
};

export const storeGuestIdFromHeaders = (headers: ResponseHeaders) => {
  const headerValue =
    headers.get?.("x-guest-id") ??
    headers["x-guest-id"] ??
    headers["X-Guest-Id"];
  const guestId = Array.isArray(headerValue) ? headerValue[0] : headerValue;

  storeGuestId(typeof guestId === "string" ? guestId : null);
};

export const clearGuestResumeSession = () => {
  localStorage.removeItem(GUEST_RESUME_EXPIRY_STORAGE_KEY);
  localStorage.removeItem("resume");
};

export const storeGuestResumeExpiry = (expiresInSeconds?: number | null) => {
  clearGuestResumeSession();

  if (!Number.isFinite(expiresInSeconds) || Number(expiresInSeconds) <= 0) {
    return;
  }

  const expiresAt = Date.now() + Number(expiresInSeconds) * 1000;
  localStorage.setItem(GUEST_RESUME_EXPIRY_STORAGE_KEY, String(expiresAt));
  localStorage.setItem("resume", "true");
};

export const getGuestResumeStatus = (): GuestResumeStatus => {
  const storedExpiry = localStorage.getItem(GUEST_RESUME_EXPIRY_STORAGE_KEY);
  if (!storedExpiry) return "missing";

  const expiresAt = Number(storedExpiry);
  if (!Number.isFinite(expiresAt) || expiresAt <= Date.now()) {
    clearGuestResumeSession();
    return "expired";
  }

  return "valid";
};

export const getGuestAwareHeaders = (): Record<string, string> => {
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  };
  const token = localStorage.getItem("token");
  const guestId = getGuestId();

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  } else if (guestId) {
    headers["X-Guest-Id"] = guestId;
  }

  return headers;
};

export const getBenefitsGuestAwareHeaders = (): Record<string, string> => {
  const headers = getGuestAwareHeaders();
  const guestId = getGuestId();
  if (guestId) headers["X-Guest-Id"] = guestId;
  return headers;
};

export const getGuestParticipantId = () => {
  const backendGuestId = getGuestId();
  if (backendGuestId) return `guest-${backendGuestId}`;

  const storageKey = "ncludeGuestParticipantId";
  const storedId = localStorage.getItem(storageKey);
  if (storedId) return storedId;

  const participantId = `guest-${crypto.randomUUID()}`;
  localStorage.setItem(storageKey, participantId);
  return participantId;
};

export const clearGuestLoginPromptHistory = () => {
  Object.keys(sessionStorage)
    .filter((key) => key.startsWith("ncludeGuestLoginPrompt:"))
    .forEach((key) => sessionStorage.removeItem(key));
};
